export class InvolvedPersonsInVisitsList {
    $id: string;
    InvolvedPersonID: number;
    CaseID: number;
    FromEis: boolean;
    ChangeableTC: string;
    PersonTypeTC: string;
    Name: string;
    PrefixName?: string;
    Initials?: string;
    Telephone?: string;
    TelephoneWork?: string;
    TelephoneMobile?: string;
    BirthDate?: string;
    GenderTC?: string;
    LegalFormTC: string;
    BankAccount?: string;
    Comment?: string;
    EmailAddress?: string;
    PreferredContactTime?: string;
    PreferredContactMethodTC?: string;
    Address1: string;
    Address2: string;
    Address5: string;
    Address3: string;
    Address4: string;
    CountryTC: string;
    IBAN?: any;
    BIC?: any;
    Language?: any;
    BankAccountFor?: any;
    Occupation?: any;
    ToName?: any;
    CreatedDate: Date;
    CreatedByUserId?: any;

    public constructor(init?: Partial<InvolvedPersonsInVisitsList>) {
        Object.assign(this, init);
    }
}
